import { signatureList } from "constants/signature";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getSignatureList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_signature_list(pageNum, filters);
    dispatch({ type: signatureList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: signatureList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};
export const addSignature = async (formData) => {
  try {
    const res = await api.add_signature(formData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const editSignature = async (id, formData) => {
  try {
    const res = await api.edit_signature(id, formData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getSignatureById = async (id) => {
  try {
    const res = await api.get_signature_by_id(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteSignature = async (id) => {
  try {
    const res = await api.delete_signature(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};
